import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, inject, NgModule } from '@angular/core';

// import { NgbActiveModal, NgbCollapseModule, NgbDropdownModule, NgbModule } from '@ng-bootstrap';
import { NgbActiveModal, NgbCollapseModule, NgbDropdownModule, NgbModule, NgbTooltipModule, NgbAlertModule, NgbCarouselModule, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { provideFirebaseApp, initializeApp, FirebaseOptions } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { environment } from '../environments/environment';
// import { DraggableDirective } from './d3/directives/draggable.directive';
import { CommonModule } from '@angular/common';

// import { D3_DIRECTIVES } from './d3';
// import { GraphComponent } from './visuals/graph/graph.component';
// import { SHARED_VISUALS } from './visuals/shared';
// import { D3TreeService } from './d3/services/d3-tree.service';
// import { TreeVisualComponent } from './visuals/tree/tree.component';
import { StepDetailsComponent } from './visuals/step-details/step-details.component'
import { StepTemplateComponent } from './visuals/step-template/step-template.component';
import { PathService } from './d3/services/path.service';
import { StepService } from './d3/services/step.service';
// import { ChoiceTemplateComponent } from './visuals/choice-template/choice-template.component';
import { DecisionWizardComponent } from './visuals/decision-wizard/decision-wizard.component';
import { DecisionService } from './d3/services/decision.service';
// import { PathNavigationComponent } from './visuals/path-navigation/path-navigation.component';
import { PathSummaryComponent } from './visuals/path-summary/path-summary.component';
import { WelcomeComponent } from './visuals/welcome/welcome.component';
import { NotFoundComponent } from './visuals/not-found/not-found.component';
// import { NgPipesModule } from 'ngx-pipes';
// import { PathComponent } from './visuals/path/path.component';
import { AuthComponent } from './visuals/auth/auth.component';
import { FooterComponent } from './visuals/footer/footer/footer.component';
import { MenuNavComponent } from './visuals/menu-nav/menu-nav.component';
import { SummaryCollapserDirective } from './directives/summary-collapser/summary-collapser.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
// import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { FeedbackComponent } from './visuals/feedback/feedback.component';
import { DecisionResolver } from './services/resolver/decision-resolver';
import { PathResolver } from './services/resolver/path-resolver';
// import { PathIntroComponent } from './visuals/path-intro/path-intro.component';
import { CookieComponent } from './visuals/cookie/cookie.component';
import { CookieService } from 'ngx-cookie-service';
import { CookiePolicyComponent } from './visuals/cookie-policy/cookie-policy.component';
import { AdvertisementService } from './services/advertisement/advertisement.service';
import { GoodbyeComponent } from './visuals/goodbye/goodbye.component';
import { PricingComponent } from './visuals/pricing/pricing/pricing.component';
import { PConfirmComponent } from './visuals/pricing/pconfirm/pconfirm.component';
// import { PaymentComponent } from './visuals/pricing/payment/payment.component';
import { D3VisualizationComponent } from './visuals/path/d3-visualization.component';
import { AngularFireModule } from '@angular/fire/compat/public_api';
// import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { ReversePipe } from './services/pipes/reverse';
import { I18NEXT_SERVICE, I18NextModule } from 'angular-i18next';
import { I18N_PROVIDERS } from './i18next-provider';
import { NO_ERRORS_SCHEMA } from '@angular/compiler';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { PaymentComponent } from './visuals/pricing/payment/payment.component';

@NgModule({
  declarations: [
     AppComponent,
    // DraggableDirective,
    // GraphComponent,
    // TreeVisualComponent,
    // ...SHARED_VISUALS,
    // ...D3_DIRECTIVES,
    ReversePipe,
    StepDetailsComponent,
    StepTemplateComponent,
    // ChoiceTemplateComponent,
    DecisionWizardComponent,
    // PathNavigationComponent, //Handles the navigation
    PathSummaryComponent, 
    WelcomeComponent, 
    NotFoundComponent, 
    // PathComponent,
    AuthComponent,
    FooterComponent, 
    MenuNavComponent, 
    SummaryCollapserDirective, 
    FeedbackComponent, 
    // PathIntroComponent, 
    CookieComponent, 
    CookiePolicyComponent, 
    GoodbyeComponent, 
    PricingComponent, 
    PConfirmComponent,
    PaymentComponent, 
    D3VisualizationComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule, //Used as part of the reactive form group
    //Bootstrap modules
    NgbModule, //This is all the libaries in this module
    //NgbPaginationModule,
    NgbDropdownModule, //For the dropdown module
    NgbCollapseModule,
    NgbTooltipModule,
    NgbAlertModule,
    NgbCarouselModule,
    // NgPipesModule, //For the reverse array pipe used in the path-summary
    HttpClientModule,
    AppRoutingModule,
    // AngularFireAnalyticsModule,
    // RecaptchaV3Module
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    provideDatabase(() => getDatabase()),
    I18NextModule.forRoot()
  ],
  providers: [
    // AngularFireDatabaseModule,
    // AngularFire
    // AngularFireModule.initializeApp(environment.firebaseConfig),
    // AngularFireAnalyticsModule,

    ScreenTrackingService,
    UserTrackingService,
    
    DecisionResolver,
    PathResolver,
    PathService,
    // D3Service, 
    // D3TreeService,
    NgbActiveModal,
    StepService,
    DecisionService,
    CookieService,
    AdvertisementService,
    // { provide: RECAPTCHA_V3_SITE_KEY, 
    //   useValue: environment.captchaConfig.options?.invisible?.sitekey || environment.captchaConfig.options?.normal?.sitekey 
    // },
    // provideHttpClient(withInterceptorsFromDi()),
     I18N_PROVIDERS, 
    // [
    //   {
    //     provide: NgbCarouselConfig,
    //     useFactory: (config: NgbCarouselConfig) => {
    //       config.wrap = false;
    //       config.keyboard = false;
    //       config.showNavigationArrows = false;
    //       config.showNavigationIndicators = false;
    //       return config;
    //     },
        // deps: [NgbCarouselConfig]
    //   }
    // ]
  ],
  bootstrap: [AppComponent],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
